import { render } from "./Login.vue?vue&type=template&id=24901e89&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=24901e89&lang=scss&scoped=true"

import exportComponent from "/builds/blat/bcard-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24901e89"]])

export default __exports__